import { render } from "./TipLamp.vue?vue&type=template&id=034bfb1e&scoped=true"
import script from "./TipLamp.vue?vue&type=script&lang=js"
export * from "./TipLamp.vue?vue&type=script&lang=js"

import "./TipLamp.vue?vue&type=style&index=0&id=034bfb1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034bfb1e"]])

export default __exports__